module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    attrs: {
      "label": "Edycja",
      "error": _vm.errors,
      "required": _vm.required
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "value": _vm.value,
      "clearable": _vm.clearable,
      "placeholder": "Edycja"
    },
    on: {
      "change": function($event) {
        return _vm.$emit('input', $event)
      }
    }
  }, _vm._l((_vm.$store.state.editions), function(edition) {
    return _c('el-option', {
      key: edition.id,
      attrs: {
        "label": edition.year,
        "value": edition.id
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c0c0334"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionInput.vue
// module id = 774
// module chunks = 0